<template>
  <div>
    <vue-title :title="$t('dashboard.title')" />
    <FCCCompetitionDetails :summary="this.summary" :reload="this.reload" />
      <v-row no-gutters>
        <v-col cols="12" sm="6" v-if="this.summary.applications">
          <div class="d-flex flex-row ml-4 flex-wrap flex-grow-1" v-if="summary">
            <FCCCompetitionApplications v-if="this.summary.applications" :summary="this.summary" :reload="this.reload" class="align-self-start" />
            <FCCCompetitionPayments v-if="this.summary.payments" :summary="this.summary" :reload="this.reload" class="align-self-start" />
            <FCCCompetitionShirts v-if="this.summary.shirts" :summary="this.summary" :reload="this.reload" class="align-self-start" />
            <FCCCompetitionCompetitors v-if="this.summary.countries" :summary="this.summary" :reload="this.reload" class="align-self-start" />
          </div>
        </v-col>
        <v-col cols="12" :sm="this.summary.applications?6:12" >
          <FCCCompetitionMessages ref="fccMessages" />
        </v-col>
      </v-row>
  </div>
</template>

<script>
import {
  VTooltip,
  VCard,
} from "vuetify/lib";
import fccapi from "../fccapi";
import pdfMake from 'pdfmake';
import fonts from '../vfs_fonts.js';
import FCCCompetitionDetails from '../components/dashboard/FCCCompetitionDetails'
import FCCCompetitionPayments from '../components/dashboard/FCCCompetitionPayments'
import FCCCompetitionShirts from '../components/dashboard/FCCCompetitionShirts'
import FCCCompetitionCompetitors from '../components/dashboard/FCCCompetitionCompetitors'
import FCCCompetitionApplications from '../components/dashboard/FCCCompetitionApplications'
import FCCCompetitionMessages from '../components/dashboard/FCCCompetitionMessages'
pdfMake.vfs = fonts;

export default {
  name: "Dashboard",
  data: () => ({
    drawer: null,
    dateofbirth: "",
    summary: {}
  }),
  computed: {
    genders: function() {
      return [this.$t("profile.male"), this.$t("profile.female")];
    },
    selectedCompetition: function() {
      return this.$store.getters['competitionId'];
    }
  },
  props: {
    source: String
  },
  components: {
    VCard,
    VTooltip,
    FCCCompetitionDetails,
    FCCCompetitionPayments,
    FCCCompetitionShirts,
    FCCCompetitionCompetitors,
    FCCCompetitionApplications,
    FCCCompetitionMessages
  },
  methods: {
    reload: function(){
      fccapi.competitionGet("summary").then(d => {
        this.summary = d.data;
        if(this.summary.countries) this.summary.countries.sort(c => c.count);
      })
    }
  },
  mounted() {
    this.reload();
  },
  watch: {
    selectedCompetition() {
      this.reload();
    }
  }
};
</script>
<style>
td{
  padding: 5px !important;
}
</style>